import { withPrefix } from 'gatsby';

import { T } from '@fire/i18n/i18n-constants';

export const ARROW_RIGHT = withPrefix('/icons/icon-arrow-right-blue.svg');
export const PREFIX = T?.FlexibleDates;
